<template>
	<div>
		<top-header v-if="$route.path == '/manage/document'"></top-header>
		<manage-header v-else></manage-header>
		<router-view></router-view>
	</div>
</template>
<script>
	import topHeader from '../components/topHeader'
	import manageHeader from '../components/ManageHeader'

	export default{
		components: {
			topHeader,
			manageHeader
		}
	}
</script>


// WEBPACK FOOTER //
// Manage.vue?7f31eb7a